"use client";

import { useStorage } from "../../useStorage";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useGetLomdaV2 } from "./hooks/useGetLomdaV2";
import { LoaderCircle } from "lucide-react";
import LomdaV2SheetMain from "./components/main";
import LomdaV2SheetHeader from "./components/header/header";
import LomdaV2SheetAside from "./components/aside";

export default function LomdaV2Sheet() {
    const [open, setOpen, options] = useStorage((state) => [
        state.lomdaV2SheetOpen,
        state.setLomdaV2SheetOpen,
        state.lomdaV2Options,
    ]);


    const { isPending, data } = useGetLomdaV2(
        open && !!options.lomdaId && !!options.libraryId,
        options.lomdaId
    );
    const lomda = data?.data;

    return (
        <Sheet open={open} onOpenChange={(open) => setOpen(open)}>
            <SheetContent
                className="bg-muted !p-0 w-full sm:w-[80vw] sm:max-w-[1200px]"
                xClassName="sm:top-4 sm:-left-10 sm:flex sm:justify-center sm:items-center sm:rounded-full sm:bg-white sm:size-6"
            >
                {isPending || !lomda ? (
                    <div className="flex w-full h-full justify-center items-center">
                        <LoaderCircle className="size-6 animate-spin" />
                    </div>
                ) : (
                    <>
                        <LomdaV2SheetHeader lomda={lomda} />

                        <div className="flex overflow-y-auto h-[calc(100%-64px)] flex-col lg:flex-row">
                            <LomdaV2SheetAside lomda={lomda} />
                            <LomdaV2SheetMain lomda={lomda} />
                        </div>
                    </>
                )}
            </SheetContent>
        </Sheet>
    );
}
